import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ModuleStepper from "./ModuleStepper";
import ModuleListCard from "./ModuleListCard";
import ModuleContent from "./ModuleContent";
import { Button, Modal } from "react-bootstrap";
import './Module.scss';
import CannotExitImage from "../../../images/Cannotexist.svg";
import BlueCheckBox from "../../../images/bluecheckbox.svg";
import MustExist from "../../../images/MustExist.svg";
import DashboardImage from "../../../images/DashboardImage.svg";
import SelectedModuleModal from "./SelectedModuleModal";
import ValueContext from "../../../utils/contextAPI/contextAPI";
import {
  getVeevaLinkedModulesListByid, sendModuleCardtoEditor, updateMMModuleCardsinEditor,
  updateModuleCardsinEditor, getAllScripts, updatSlideData
} from "../../../services/apis";
import CustomTooltip from "../../Tooltip/Tooltip";

const Module = (props) => {
  const {
    displayModal,
    hideModal,
    size,
    centered,
    keyboard,
    enforceFocus = true,
    handleSearchModalHide,
    brands,
    market,
    setSearhModuleModal,
    veevaModule,
    setVeevaContentData,
    getVeevaModuleCardinfo,
    isEditModuleList,
    searchedText,
    selectedCategory,
    setlinkedSearchExpression,
    slideID,
    getVeevaLinkedmodules,
    setLinkedModule,
    editModuleSelection,
    setEditModuleSelection,
    hasFetched, 
    setHasFetched,

    } = props;
    
    const [show, setShow] = useState(false);
    const [activeStep, setActiveState] = useState(0);
    const [hideModuleContent, setHideModuleContent] = useState(true);
    const appData = useContext(ValueContext);
    const [activeNextButton, setActiveNextButton] = useState(false);
    const [closeTootltipTitle, setCloseTootltipTitle] = useState(true);
    const [selectedModuleIds, setSelectedModuleIds] = useState([]); // Main state when user select any particular card, setting particular id in this state
    const [switchCustomJs, setSwitchCustomJs] = useState(false);
    const[moduleDetails, setModuleDetails] = useState([]);
    const[prevModuleDetails, setPrevModuleDetails] = useState([]);
  const [editModuleStepper, setEditModuleStepper] = useState(2);
  const [getAllrelatedClaims, setAllrelatedClaims] = useState([]);
    const [selectedModulesData, setSelectedModulesData] = useState({});

      const { pageId } = useParams();
  useEffect(() => {
      getPreviousrelatedCalims();
    },[])
    useEffect(() => {
      setShow(displayModal);
      setCloseTootltipTitle(true);
      getPreviousrelatedCalims()
      // getmmModules(aa)
    }, [displayModal]);
  const getPreviousrelatedCalims = () => {
    getAllScripts(pageId, (response, err, errorCode) => {
        if (err) {
          // setIsloading(false);
        } else {
          // setIsloading(false);
          const selectedRelatedClaims = response?.data?.relatedClaimsData;
          setAllrelatedClaims(selectedRelatedClaims);        
          
        }
  });
  }
  
  const updateCardsSlideLevel = (payLoad) => {
     updatSlideData(pageId, payLoad, (response, err, errorCode) => {
    
                if (err) {
                  // setIsloading(false);
                } else {
                  // setIsloading(false);
                  console.log("====res", response);
                }
              });
  }
 

    const moduleLists = moduleDetails?.filter(li => selectedModuleIds.includes(li.id));
    const setModalHide = () => {
      setShow(false);
      hideModal(false);
      setHideModuleContent(true);
      setCloseTootltipTitle(true);
    };

    // useEffect(() => {
    //   getModules()
    // }, [moduleDetails.length > 0]);

    useEffect(() => {
      if (!hasFetched && moduleDetails.length > 0) {
        getModules();
        setHasFetched(true);
      }
    }, [moduleDetails, hasFetched]);
    
    // useEffect(() => {
    //   if (!hasFetched && moduleDetails.length > 0) {
    //     getModules();
    //     setHasFetched(true);
    //   }
    // }, [moduleDetails, hasFetched]);

    const getModules=()=>{
      getVeevaLinkedModulesListByid(appData?.deckId?._id, (response, err, errorCode) => {
        if (err) {
          console.log(err); 
        }
        else {
          let ids = [];
          const data = response?.data?.response?.content_modules;
          data.map(id => {
            moduleDetails.forEach(li => {
              if(li.moduleDamName === id.module_name) {
                    ids.push(li.id);
                  }
                })
              })
              const selectedListIds = data && data.map(li => li.content_module_response.id);
              // setSelectedModuleIds(selectedListIds);
              setSelectedModuleIds(ids);
          setPrevModuleDetails(ids);
        }
        appData.setDeckId({...appData.deckId, selected_module_data: response?.data?.response.selected_module_data})
                // setModuleCardsDataLHS(response.data.response.content_modules)
      });
    }
    const NextContentModule = () => {
        let veevaArr = [];
        moduleLists.forEach((vModule) => {
          let newObject = {
            moduleid: vModule?.moduleDamId,
            module_name: vModule?.moduleDamName,
            content_module_response: {
              moduleDamId: vModule?.moduleDamId,
              moduleDamName: vModule?.moduleDamName,
              countryName:vModule.countryName,
              productName:vModule.productName,
              moduleBusinessRules: vModule?.moduleBusinessRules,
              moduleName: vModule?.moduleName,
              id:vModule.id
            }
          };
          veevaArr.push(newObject);
        });
        const uniqueModules = [];
        const seenModuleIds = new Set();

        for (const item of veevaArr) {
          if (!seenModuleIds.has(item.moduleid)) {
            seenModuleIds.add(item.moduleid);
            uniqueModules.push(item);
          }
        }
        appData.deckId.module_type = "NEXT";
        let veevaPayload = {
          deckid: appData.deckId._id,
          module_type: "NEXT",
          search_expression: {
            brand_name: "Biktarvy",
            claim_category: selectedCategory,
            name: searchedText,
            // campaign: getBrandAndMarketCamp("campaign"),
          },
    
          content_modules: [...uniqueModules],
        };
        console.log('================== data asso', selectedModulesData, uniqueModules)
        let searchedEdtiorData = {
          // brand_name: getBrandAndMarketCamp("brand"),
          claim_category: selectedCategory,
          name: searchedText,
          // campaign: getBrandAndMarketCamp("campaign"),
        };
        setlinkedSearchExpression(searchedEdtiorData);
        // setIsloading(true);
        if (!isEditModuleList) {
          
          updateModuleCardsinEditor(appData?.deckId?._id, veevaPayload, (response, err, errorCode) => {
            if (err) {
              console.log(err);
              setSearhModuleModal(false);
            } else {
              let resp = response.data;
              setVeevaContentData(resp);
              let veevaData = [];
              veevaModule.forEach((item) => veevaData.push(item.id));
              getVeevaModuleCardinfo(moduleLists);
               const IdsModule = new Set(uniqueModules.map(item => item.module_name));
          const filterClaims = getAllrelatedClaims.filter(item => IdsModule.has(item.moduleId));
          const payLoad = {
        relatedClaimsData: filterClaims,
              }; 
              updateCardsSlideLevel(payLoad);
              let IDRef =
              JSON.stringify(slideID.child) === "{}"
              ? slideID.master?.slideid?._id
                  : slideID.child?.slideid?._id;
              
              getVeevaLinkedmodules(IDRef);
              setLinkedModule("VEEVA");
              setSwitchCustomJs(false);
              setSearhModuleModal(false);
            }
          });
        } else {
        
        }
        setEditModuleSelection(false);
      };

    const closeTootltip = () => {
      setCloseTootltipTitle(false);
    }

    const steps = ['Import Module', 'Select Template', 'Author e-Detail', 'Generate RSD', 'Publish'];
    return (
        <Modal
          show={show}
          onHide={setModalHide}
          size={size ? size : ""}
          centered={centered ? centered : "false"}
          // className={dilogClassName}
          backdrop={props.backdrop || "static"}
          keyboard={keyboard}
          enforceFocus={enforceFocus}
          fullscreen={true}
          dilogClassName="module-modal"
          className="module-modal"
          >
          <Modal.Header className="m-0 p-0 module-content-header">
              <div className="module-content-dashboard">
                <div className="d-flex align-items-center module-content-dashboard-header">
                  <div className="module-content-dashboard-image">
                    <img src={DashboardImage} alt="" onClick={setModalHide}/>
                  </div>
                  <div className="module-content-dashboard-title">
                    <h4>Create e-Detail</h4>
                    <CustomTooltip title={appData?.deckId?.name} classes="dashboard-title-name-tooltip">
                      <h2>{appData?.deckId?.name}</h2>
                    </CustomTooltip>
                  </div>
                </div>
                <div className="module-content-modal-promomats">
                  {/* <h4 className="module-content-modal-promomats-source">Source</h4> */}
                  <strong className="module-content-modal-promomats-title">PromoMats</strong>
                </div>
              </div>
              <div>
                <ModuleStepper editModuleSelection={editModuleSelection} activeStep={editModuleSelection ? editModuleStepper : activeStep} steps={steps}/>
              </div>
          </Modal.Header>
          <Modal.Body className="m-0 p-0 module-modal-body">
            <ModuleContent 
              selectedModuleIds={selectedModuleIds} 
              setSelectedModuleIds={setSelectedModuleIds} 
              setActiveNextButton={setActiveNextButton}
              switchCustomJs={switchCustomJs} 
              setSwitchCustomJs={setSwitchCustomJs}
              moduleDetails={moduleDetails} 
              setModuleDetails={setModuleDetails} 
              brands={brands}
              appData={appData}
              market={market}
              from="edit"
              closeTootltipTitle={closeTootltipTitle}
            closeTootltip={closeTootltip}
            setSelectedModulesData={setSelectedModulesData}
            selectedModulesData={selectedModulesData}
            />
          </Modal.Body>
          <Modal.Footer className="module-modal-footer">
            <div className="d-flex align-items-center" style={{gap: "20px"}}>
              {!switchCustomJs && <>
              <div className="d-flex align-items-center">
                <img src={BlueCheckBox} alt="image" className="module-modal-footer-image"/>
                <h3 className="module-modal-footer-text">Selected Module</h3>
              </div>
              <div className="d-flex align-items-center">
                <img src={CannotExitImage} alt="image" className="module-modal-footer-image"/>
                <h3 className="module-modal-footer-text">Cannot exist with</h3>
              </div>
              <div className="d-flex align-items-center">
                <img src={MustExist} alt="image" className="module-modal-footer-image"/>
                <h3 className="module-modal-footer-text">Must use or Related (Optional)</h3>
              </div>
              </>}
            </div>
            <div>
              <Button variant="" className="module-modal-footer-cancel"
                onClick={() => {
                  handleSearchModalHide();
                  setSwitchCustomJs(false);
                  setSelectedModuleIds(prevModuleDetails);
                  setEditModuleSelection(false);
                  setHasFetched(false);
                  // setUserSelctedModuleList(prevSelectedCrds);
                }}>
                CANCEL
              </Button>
              <Button variant="" className={`module-modal-footer-next ${activeNextButton ? "module-modal-footer-next-active" : "module-modal-footer-next-deactive"}`} 
                disabled={!activeNextButton}
                onClick={NextContentModule}>
                NEXT
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
    )
}

export default Module;